export enum MessageEntityType {
  Project,
  WorkUnit,
}
